import SchoolyearPlanning from "../views/schooladmin/SchoolyearPlanning";
import SchoolyearPlanningAddEdit from "../views/schooladmin/SchoolyearPlanningAddEdit";

export default [
	{
		path: "/schooladmin/schoolyear_planning",
		components: {
			content: SchoolyearPlanning
		}
	},
	{
		path: "/schooladmin/schoolyear_planning/new",
		components: {
			content: SchoolyearPlanningAddEdit
		}
	},
	{
		path: "/schooladmin/schoolyear_planning/update/:id",
		components: {
			content: SchoolyearPlanningAddEdit
		},
		props: {
			content: true
		}
	}
];
